import React from "react";
import { Card } from "antd";
import envUrls from "../../../../config/env-urls";

const REACT_APP_ENV = process.env.REACT_APP_ENV || "dev";
const reportBaseURL = envUrls[REACT_APP_ENV].API.reportBaseURL;

const ModernViewCard = ({ newReportUrl }) => {
  const newReportFullPath = newReportUrl?.startsWith("http")
    ? newReportUrl
    : `${reportBaseURL}${newReportUrl}`;

  return (
    <div className="redirect-card-container">
      <Card
        className="redirect-card"
        onClick={() => window.open(newReportFullPath, "_blank")}
      >
        <div className="redirect-content">
          <div className="sparkle-icon">{"\u2728"}</div>
          <h2>New Version Available</h2>
          <p>
            Experience the future of reporting with our modern, high-performance interface. 
            All your data, now with better visibility and faster insights.
          </p>
          <div className="redirect-btn">Explore Modern View {"\u2728"}</div>
        </div>
      </Card>
    </div>
  );
};

export default ModernViewCard;
